module.exports = __webpack_public_path__ + "static/media/LowerRoswell_banner.aa9864b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/projects/LowerRoswell_banner.jpg
// module id = 476
// module chunks = 0